import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

import * as BiIcons from "react-icons/bi";
import { motion, AnimatePresence } from "framer-motion";
import { AppContext } from "../../../Contexts/AppContext";

const ErrorPopup = forwardRef((props, ref) => {
  const context = useContext(AppContext);
  const [currentText, setCurrentText] = useState("");
  const [currentBG, setCurrentBG] = useState("");
  const [errorPopup, setErrorPopup] = useState(false);
  useEffect(() => {
    if (errorPopup) {
      setTimeout(() => setErrorPopup(false), 10000);
    }
    setCurrentText(
      context.isLight
        ? context.currentTheme["default"].text
        : context.currentTheme["default"].dark_text
    );
    setCurrentBG(
      context.isLight
        ? context.currentTheme["default"].dropdown
        : context.currentTheme["default"].dark_dropdown
    );
  }, [context, errorPopup]);

  useImperativeHandle(ref, () => {
    return {
      openTrigger: () => setErrorPopup(true),
      closeTrigger: () => setErrorPopup(false),
    };
  });
  return (
    <AnimatePresence>
      {errorPopup && (
        <motion.div
          initial={{
            opacity: 0,
            x: -1000,
          }}
          animate={{
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.5,
              ease: "easeInOut",
            },
          }}
          exit={{
            opacity: 0,
            x: -1000,
            transition: {
              duration: 0.5,
              ease: "easeInOut",
            },
          }}
          className="fixed bottom-[2%] left-[1%] right-[1%] flex items-center rounded py-2 px-4 shadow-[0_0px_8px_0px_#000c] ss:right-auto"
          style={{ backgroundColor: currentBG, color: currentText }}
        >
          <BiIcons.BiErrorAlt className="text-xl text-red-500" />
          <p className="ml-2 text-sm font-thin before:absolute before:top-[3%] before:left-2 before:h-[94%] before:w-[2px] before:rounded-full before:bg-red-500 sm:text-base">
            {props.message}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default ErrorPopup;
